module.exports = __webpack_public_path__ + "static/media/ios-jet.930e88d8.svg";